import { ITimezone } from 'redhotpie-shared-lib/interfaces/ITimezone';

export default class Timezone {
  abbrDaylight: string;
  abbrGeneric: string;
  abbrStandard: string;
  baseUtcOffset: string;
  daylightName: string;
  daylightOffset: string;
  id: string;
  ianaName: string;
  isDaylightSavingTime: boolean;
  standardName: string;
  supportsDaylightSavingTime: boolean;
  windowsName: string;

  constructor() {
    this.abbrDaylight = '';
    this.abbrGeneric = '';
    this.abbrStandard = '';
    this.baseUtcOffset = '';
    this.daylightName = '';
    this.daylightOffset = '';
    this.id = '';
    this.ianaName = '';
    this.isDaylightSavingTime = false;
    this.standardName = '';
    this.supportsDaylightSavingTime = false;
    this.windowsName = '';
  }

  static mappingObject(_obj: any): ITimezone {
    const obj = new Timezone();
    obj.abbrDaylight = _obj.AbbrDaylight || '';
    obj.abbrGeneric = _obj.AbbrGeneric || '';
    obj.abbrStandard = _obj.AbbrStandard || '';
    obj.baseUtcOffset = _obj.BaseUtcOffset || '';
    obj.daylightName = _obj.DaylightName || '';
    obj.daylightOffset = _obj.DaylightOffset || '';
    obj.id = _obj.ID || '';
    obj.ianaName = _obj.IanaName || '';
    obj.isDaylightSavingTime = _obj.IsDaylightSavingTime || false;
    obj.standardName = _obj.StandardName || '';
    obj.supportsDaylightSavingTime = _obj.SupportsDaylightSavingTime || false;
    obj.windowsName = _obj.WindowsName || '';

    return obj;
  }

  static mappingObjectListTimezone(_timezone: any): ITimezone[] {
    const listTimezone: ITimezone[] = [];
    _timezone.forEach((itm: any) => {
      const timezoneItem = Timezone.mappingObject(itm);
      listTimezone.push(timezoneItem);
    });

    return listTimezone;
  }
}
